module.exports = __webpack_public_path__ + "img/icon-reset.f0d03e8f.svg";